// API Configuration (for future use)
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:7071/api';

// App Configuration
export const APP_NAME = 'Team Jak Events';
export const APP_DESCRIPTION = 'Register for Team Jak charity events and activities';

// Drawer Configuration
export const DRAWER_WIDTH = 280;
export const MINI_DRAWER_WIDTH = 72;

// Routes
export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  MAGIC_LINK: '/auth/magic-link',
  SSO_CALLBACK: '/auth/callback',

  // Family routes
  DASHBOARD: '/dashboard',
  EVENTS: '/events',
  EVENT_DETAIL: '/events/:id',
  MY_REGISTRATIONS: '/my-registrations',
  MY_GUESTS: '/my-guests',
  FAMILY_MEMBERS: '/family-members',
  PROFILE: '/profile',
  FEEDBACK: '/feedback',
  FEEDBACK_EVENT: '/feedback/:eventId',
  SUPPORT: '/support',

  // Volunteer routes
  VOLUNTEERS: '/volunteers',
  VOLUNTEER_SHIFTS: '/volunteers/shifts',
  VOLUNTEER_SHIFT_DETAIL: '/volunteers/shifts/:id',
  VOLUNTEER_MY_SHIFTS: '/volunteers/my-shifts',
  VOLUNTEER_PROFILE: '/volunteers/profile',

  // Admin routes
  ADMIN_DASHBOARD: '/admin',
  ADMIN_EVENTS: '/admin/events',
  ADMIN_CREATE_EVENT: '/admin/events/create',
  ADMIN_EDIT_EVENT: '/admin/events/:id/edit',
  ADMIN_ATTENDEES: '/admin/attendees',
  ADMIN_EVENT_ATTENDEES: '/admin/events/:id/attendees',
  ADMIN_EVENT_REGISTER: '/admin/register',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_SETTINGS: '/admin/settings',
  ADMIN_LOCATIONS: '/admin/locations',
  ADMIN_CATEGORIES: '/admin/categories',
  ADMIN_CHECK_IN: '/admin/events/:id/check-in',
  ADMIN_QR_CHECK_IN: '/admin/qr-check-in',
  ADMIN_NOTIFICATIONS: '/admin/notifications',
  ADMIN_NOTIFICATION_LOG: '/admin/notification-log',

  // Admin volunteer routes
  ADMIN_VOLUNTEERS: '/admin/volunteers',
  ADMIN_VOLUNTEER_SHIFTS: '/admin/volunteer-shifts',
  ADMIN_VOLUNTEER_SHIFT_CREATE: '/admin/volunteer-shifts/create',
  ADMIN_VOLUNTEER_SHIFT_EDIT: '/admin/volunteer-shifts/:id/edit',
  ADMIN_VOLUNTEER_SHIFT_DETAIL: '/admin/volunteer-shifts/:id',
  ADMIN_VOLUNTEER_REPORTS: '/admin/volunteer-reports',
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'teamjak_auth_token',
  USER: 'teamjak_user',
  THEME_MODE: 'teamjak_theme_mode',
  CAMERA_DEVICE_ID: 'teamjak_camera_device_id',
} as const;

// Date Formats
export const DATE_FORMAT = 'MMMM d, yyyy';
export const TIME_FORMAT = 'h:mm a';
export const DATE_TIME_FORMAT = 'MMMM d, yyyy h:mm a';
